import { render, staticRenderFns } from "./FloatingPlayButton.vue?vue&type=template&id=3b0c6b6c"
import script from "./FloatingPlayButton.vue?vue&type=script&lang=js"
export * from "./FloatingPlayButton.vue?vue&type=script&lang=js"
import style0 from "./FloatingPlayButton.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports